export const supplierFormFields = {
    supplierDataForm: [

        {
            order: 0,
            rowClass: "row",
            name: "row-0",
            fields: [
                {
                    order: 0,
                    name: "name", // name is also a key in JSON
                    value: null,
                    type: "text", // available types: text, number, date, checkbox, select, list and button
                    label: "Nazwa dostawcy",
                    required: true,
                    options: [], // for select type
                    minLength: 3, // used only to validate text fields
                    maxLength: 255, // used only to validate text fields
                    pattern: "",
                    placeholder: "Uzupełnij nazwę dostawcy",
                    helpText: "Pole musi zawierać od 3 do 255 znaków",
                    colClass: "col",
                },
            ],
        },
        {
            order: 1,
            rowClass: "row",
            name: "row-1",
            fields: [
                {
                    order: 0,
                    name: "address", // name is also a key in JSON
                    value: null,
                    type: "text", // available types: text, number, date, checkbox, select, list and button
                    label: "Adres dostawcy",
                    required: false,
                    options: [], // for select type
                    minLength: 3, // used only to validate text fields
                    maxLength: 255, // used only to validate text fields
                    pattern: "",
                    placeholder: "Wpisz nazwę pola",
                    helpText: "Pole musi zawierać od 3 do 255 znaków",
                    colClass: "col",
                },
            ],
        },
        {
            order: 2,
            rowClass: "row",
            name: "row-2",
            fields: [
                {
                    order: 0,
                    name: "city", // name is also a key in JSON
                    value: null,
                    type: "text", // available types: text, number, date, checkbox, select, list and button
                    label: "Miasto",
                    required: false,
                    options: [], // for select type
                    minLength: 3, // used only to validate text fields
                    maxLength: 255, // used only to validate text fields
                    pattern: "",
                    placeholder: "Wpisz nazwę pola",
                    helpText: "Pole musi zawierać od 3 do 255 znaków",
                    colClass: "col-9",
                },
                {
                    order: 0,
                    name: "zipcode", // name is also a key in JSON
                    value: null,
                    type: "text", // available types: text, number, date, checkbox, select, list and button
                    label: "Kod pocztowy",
                    required: false,
                    options: [], // for select type
                    minLength: 3, // used only to validate text fields
                    maxLength: 255, // used only to validate text fields
                    pattern: "",
                    placeholder: "Wpisz nazwę pola",
                    helpText: "Pole musi zawierać od 3 do 255 znaków",
                    colClass: "col-3",
                },
            ],
        },
        {
            order: 4,
            rowClass: "row",
            name: "row-4",
            fields: [
                {
                    order: 0,
                    name: "bankAccount", // name is also a key in JSON
                    value: null,
                    type: "text", // available types: text, number, date, checkbox, select, list and button
                    label: "Numer konta bankowego",
                    required: false,
                    options: [], // for select type
                    minLength: 3, // used only to validate text fields
                    maxLength: 255, // used only to validate text fields
                    pattern: "",
                    placeholder: "Wpisz nazwę pola",
                    helpText: "Pole musi zawierać od 3 do 255 znaków",
                    colClass: "col-9",
                },
                {
                    order: 0,
                    name: "bankName", // name is also a key in JSON
                    value: null,
                    type: "text", // available types: text, number, date, checkbox, select, list and button
                    label: "Bank",
                    required: false,
                    options: [], // for select type
                    minLength: 3, // used only to validate text fields
                    maxLength: 255, // used only to validate text fields
                    pattern: "",
                    placeholder: "Wpisz nazwę pola",
                    helpText: "Pole musi zawierać od 3 do 255 znaków",
                    colClass: "col-3",
                },
            ],
        },
        {
            order: 6,
            rowClass: "row",
            name: "row-6",
            fields: [
                {
                    order: 0,
                    name: "nip", // name is also a key in JSON
                    value: null,
                    type: "text", // available types: text, number, date, checkbox, select, list and button
                    label: "NIP dostawcy",
                    required: true,
                    options: [], // for select type
                    minLength: 3, // used only to validate text fields
                    maxLength: 255, // used only to validate text fields
                    pattern: "",
                    placeholder: "Uzupełnij numer NIP",
                    helpText: "Pole musi zawierać od 3 do 255 znaków",
                    colClass: "col",
                },
            ],
        },
        {
            order: 7,
            rowClass: "row",
            name: "row-7",
            fields: [
                {
                    order: 0,
                    name: "regon", // name is also a key in JSON
                    value: null,
                    type: "text", // available types: text, number, date, checkbox, select, list and button
                    label: "REGON dostawcy",
                    required: false,
                    options: [], // for select type
                    minLength: 3, // used only to validate text fields
                    maxLength: 255, // used only to validate text fields
                    pattern: "",
                    placeholder: "Wpisz nazwę pola",
                    helpText: "Pole musi zawierać od 3 do 255 znaków",
                    colClass: "col",
                },
            ],
        },
        {
            order: 8,
            rowClass: "row",
            name: "row-8",
            fields: [
                {
                    order: 0,
                    name: "phone", // name is also a key in JSON
                    value: null,
                    type: "text", // available types: text, number, date, checkbox, select, list and button
                    label: "Telefon dostawcy",
                    required: false,
                    options: [], // for select type
                    minLength: 3, // used only to validate text fields
                    maxLength: 255, // used only to validate text fields
                    pattern: "",
                    placeholder: "Wpisz nazwę pola",
                    helpText: "Pole musi zawierać od 3 do 255 znaków",
                    colClass: "col",
                },
            ],
        },
        {
            order: 9,
            rowClass: "row",
            name: "row-9",
            fields: [
                {
                    order: 0,
                    name: "email", // name is also a key in JSON
                    value: null,
                    type: "text", // available types: text, number, date, checkbox, select, list and button
                    label: "Email dostawcy",
                    required: false,
                    options: [], // for select type
                    minLength: 3,
                    maxLength: 255,
                    pattern: "",
                    placeholder: "Wpisz nazwę pola",
                    helpText: "Pole musi zawierać od 3 do 255 znaków",
                    colClass: "col",
                },
            ],
        },
        {
            order: 10,
            rowClass: "row",
            name: "row-10",
            fields: [
                {
                    order: 0,
                    name: "centralId", // name is also a key in JSON
                    value: null,
                    type: "text", // available types: text, number, date, checkbox, select, list and button
                    label: "Kamsoft ID",
                    required: false,
                    options: [], // for select type
                    minLength: 3,
                    maxLength: 255,
                    pattern: "",
                    placeholder: "Wpisz nazwę pola",
                    helpText: "Pole musi zawierać od 3 do 255 znaków",
                    colClass: "col-6",
                },
                {
                    order: 0,
                    name: "concestion", // name is also a key in JSON
                    value: null,
                    type: "text", // available types: text, number, date, checkbox, select, list and button
                    label: "Koncesja dostawcy",
                    required: false,
                    options: [], // for select type
                    minLength: 3,
                    maxLength: 255,
                    pattern: "",
                    placeholder: "Wpisz nazwę pola",
                    helpText: "Pole musi zawierać od 3 do 255 znaków",
                    colClass: "col-6",
                },
            ],
        },

        {
            order: 12,
            rowClass: "row",
            name: "row-12",
            fields: [
                {
                    order: 0,
                    name: "ownSupplier", // name is also a key in JSON
                    value: null,
                    type: "checkbox", // available types: text, number, date, checkbox, select, list and button
                    label: "Własny dostawca",
                    required: false,
                    options: [], // for select type
                    minLength: 3,
                    maxLength: 255,
                    pattern: "",
                    placeholder: "Wpisz nazwę pola",
                    helpText: "Pole musi zawierać od 3 do 255 znaków",
                    colClass: "col",
                },
            ],
        },
        {
            order: 13,
            rowClass: "row",
            name: "row",
            fields: [

                {
                    order: 0,
                    name: "bindLocalSuppliersActions",
                    value: null,
                    type: "slot",
                    label: "Powiązania z lokalnymi dostawcami",
                    required: false,
                    options: [],
                    helpText: "Powiązania z lokalnymi dostawcami",
                    colClass: "col",
                },
            ],
        },
    ],
};
